import { render, staticRenderFns } from "./HeroBg.vue?vue&type=template&id=0fcf508f"
import script from "./HeroBg.vue?vue&type=script&lang=js"
export * from "./HeroBg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports